"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Input = require("./Input");
var _connect = require("../connect");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- UTIL

var _previewType = function _previewType(ext) {
  if (ext === 'docx') return 'file-word blue';
  if (ext === 'mp4') return 'file-video red';
  if (ext === 'txt') return 'file-alt grey-blue';
  if (ext === 'csv') return 'file-csv orange';
  if (ext === 'pdf') return 'file-pdf red';
  if (ext === 'xlsx') return 'file-excel green';
  return 'question b grey';
};
var _preview = function _preview(ext, file) {
  if (ext) {
    var type = _previewType(ext);
    return /*#__PURE__*/React.createElement("div", {
      className: '_avatar'
    }, /*#__PURE__*/React.createElement(_Icon.default, {
      name: type
    }), /*#__PURE__*/React.createElement("div", {
      className: "_name"
    }, (file === null || file === void 0 ? void 0 : file.split('/').reverse()[0]) || ext));
  }
  return /*#__PURE__*/React.createElement(_Icon.default, {
    name: "question b",
    className: "_avatar grey"
  });
};

// ----- INTERFACE

// ----- UTILS

var reorder = function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
};

// ----- Component
var Photo = /*#__PURE__*/function (_Component) {
  _inherits(Photo, _Component);
  var _super = _createSuper(Photo);
  function Photo(props) {
    var _this;
    _classCallCheck(this, Photo);
    _this = _super.call(this, props);
    // ----- EVENT
    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (items) {
      if (_this.props.onChange) {
        if (items && items.length > 0) {
          if (_this.multiple) {
            var outputs = Array.isArray(_this.props.value) ? _this.props.value : [];
            items.forEach(function (i) {
              if (_this.props.tag) i.tag = _this.props.tag;
              outputs.push(i);
            });
            _this.props.onChange(_toConsumableArray(outputs));
          } else {
            if (_this.props.tag) {
              items[0].tag = _this.props.tag;
              var _outputs = (Array.isArray(_this.props.value) ? _this.props.value : []).filter(function (f) {
                return f.tag !== _this.props.tag;
              });
              _outputs.push(items[0]);
              _this.props.onChange(_toConsumableArray(_outputs));
            } else {
              _this.props.onChange(_objectSpread({}, items[0]));
            }
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDelete", function (item) {
      _this.noOpen();
      if (_this.props.onChange) {
        if (_this.multiple || Array.isArray(_this.props.value)) {
          var pare = JSON.stringify(item);
          _this.props.onChange(_this.props.value.filter(function (item) {
            return JSON.stringify(item) !== pare;
          }));
        } else {
          _this.props.onChange(null);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onUpload", function (files) {
      _this.noOpen();
      _this.setState({
        enter: false,
        wait: true
      });
      var data = new FormData();
      files.forEach(function (file) {
        data.append('files[]', file);
      });
      (0, _connect.post)(_this.props.url || 'upload', data).then(function (d) {
        _this.setState({
          wait: false
        }, function () {
          _this.onUpdate(d.files);
          if (_this.props.onError && d.errors && d.errors.length) _this.props.onError(d);
          _this._noOpen = false;
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onRefOpen", function () {
      if (!_this._noOpen) {
        _this.dropzoneRef.current.open();
      } else {
        _this._noOpen = false;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (result) {
      if (_this.props.onChange) {
        var source = result.source,
          destination = result.destination;
        if (!destination) {
          return;
        }
        var datas = reorder(_this.props.value, source.index, destination.index);
        _this.props.onChange(datas);
      }
    });
    // ----- UTIL
    _defineProperty(_assertThisInitialized(_this), "noOpen", function () {
      _this._noOpen = true;
      setTimeout(function () {
        _this._noOpen = false;
      }, 250);
    });
    _defineProperty(_assertThisInitialized(_this), "_getValue", function () {
      if (Array.isArray(_this.props.value)) return _this.props.value;
      if (_typeof(_this.props.value) === 'object') return [_this.props.value];
      return [];
    });
    _defineProperty(_assertThisInitialized(_this), "_multiValue", function () {
      return _this._getValue().filter(function (item) {
        return item && (item.file || item.url) && (!_this.props.tag || _this.props.tag === item.tag);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_singleValue", function () {
      if (_this.props.tag) return _this._getValue().filter(Boolean).find(function (f) {
        return f && f.tag === _this.props.tag;
      }) || [];
      return _this.props.value;
    });
    _this.state = {
      enter: false,
      wait: false,
      photoIndex: 0
    };
    _this.dropzoneRef = /*#__PURE__*/(0, React.createRef)();
    _this.multiple = !!props.multiple;
    _this._noOpen = false;
    _this.compId = Math.round(Math.random() * 1000000);
    return _this;
  }
  _createClass(Photo, [{
    key: "accept",
    value:
    // ----- RENDER

    function accept() {
      if (this.props.accept) {
        if (this.props.accept === 'all') return undefined;
        if (this.props.accept === 'doc') return '.pdf,.xlsx';
        if (this.props.accept === 'doc+image') return '.pdf,.xlsx,image/*';
      }
      return 'image/*';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var value = this.multiple ? this._multiValue() : this._singleValue();
      var clsName_box = (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-photo', this.props), this.state.enter && '-enter');
      var items;
      if (this.multiple) {
        var hasItem = !!value && value.length > 0;
        items = this.props.readOnly && !hasItem ? /*#__PURE__*/React.createElement("div", {
          className: '_items'
        }, /*#__PURE__*/React.createElement(ItemEmpty, null)) : /*#__PURE__*/React.createElement("div", {
          className: '_items'
        }, hasItem && value.map(function (item, i) {
          return /*#__PURE__*/React.createElement(Item, {
            key: 'ip_' + _this2.compId + '_' + i,
            item: item,
            noOpen: _this2.noOpen,
            readOnly: _this2.props.readOnly,
            onDelete: _this2.onDelete
          });
        }), this.state.wait && /*#__PURE__*/React.createElement("div", {
          className: "_item"
        }, /*#__PURE__*/React.createElement(_Icon.default, {
          name: "spinner",
          className: "_img-icon _wait fa-spin"
        })), !this.props.readOnly && /*#__PURE__*/React.createElement("div", {
          className: '_item _placeholder',
          onClick: this.onRefOpen
        }, /*#__PURE__*/React.createElement(_Icon.default, {
          name: "plus"
        })));
      } else {
        items = this.props.readOnly && !(value && (value.file || value.url)) ? /*#__PURE__*/React.createElement(ItemEmpty, null) : /*#__PURE__*/React.createElement(Item, {
          single: true,
          item: value,
          wait: this.state.wait,
          readOnly: this.props.readOnly,
          noOpen: this.noOpen,
          onClick: this.onRefOpen,
          onDelete: this.onDelete
        });
      }
      // this.props.readOnly
      var input = this.props.readOnly ? /*#__PURE__*/React.createElement("div", {
        className: clsName_box
      }, items, !this.props.form && !!this.props.label && (0, _Input.createInputboxLabel)(this.props.label, true)) : /*#__PURE__*/React.createElement(_reactDropzone.default, {
        accept: {
          'image/*': ['.jpeg', '.jpg', '.png']
        },
        multiple: this.multiple,
        ref: this.dropzoneRef,
        noClick: true,
        noKeyboard: true,
        onDragEnter: function onDragEnter() {
          return _this2.setState({
            enter: true
          });
        },
        onDragLeave: function onDragLeave() {
          return _this2.setState({
            enter: false
          });
        },
        onDrop: this.onUpload
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
          getInputProps = _ref.getInputProps;
        return /*#__PURE__*/React.createElement("div", _extends({
          className: clsName_box
        }, getRootProps()), /*#__PURE__*/React.createElement("input", _extends({
          title: "input-file"
        }, getInputProps())), items, !_this2.props.form && !!_this2.props.label && (0, _Input.createInputboxLabel)(_this2.props.label, true));
      });
      if (this.props.form) return (0, _Input.createFormitem)(input, this.props);
      if (typeof this.props.classBox === 'string') return /*#__PURE__*/React.createElement("div", {
        className: this.props.classBox
      }, input);
      return input;
    }
  }]);
  return Photo;
}(React.Component);
exports.default = Photo;
function ItemEmpty() {
  return /*#__PURE__*/React.createElement("div", {
    className: "_item"
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: "image",
    className: "_img-icon"
  }));
}
function Item(props) {
  var single = props.single,
    item = props.item,
    noOpen = props.noOpen,
    onDelete = props.onDelete;
  var _useMemo = (0, React.useMemo)(function () {
      var _props$item, _exec, _exec$;
      if (!props.item && !((_props$item = props.item) !== null && _props$item !== void 0 && _props$item.url)) return {
        style: undefined,
        preview: undefined,
        isImage: false
      };
      var ext = (_exec = /(?:\.([^.]+))?$/.exec(props.item.url)) === null || _exec === void 0 ? void 0 : (_exec$ = _exec[1]) === null || _exec$ === void 0 ? void 0 : _exec$.toLowerCase();
      var isImage = ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif' || ext === 'webp';
      return {
        isImage: isImage,
        style: isImage ? {
          backgroundImage: "url(\"".concat(encodeURI(props.item.thumb || item.url), "\")")
        } : undefined,
        preview: _preview(ext, props.item.url)
      };
    }, [props.item]),
    style = _useMemo.style,
    preview = _useMemo.preview,
    isImage = _useMemo.isImage;
  if (props.wait) return /*#__PURE__*/React.createElement("div", {
    className: "_item"
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: "spinner",
    className: "_img-icon _wait fa-spin"
  }));
  if (props.single && !(item && (item.file || item.url))) return /*#__PURE__*/React.createElement("div", {
    className: "_item",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(_Icon.default, {
    name: "image",
    className: "_img-icon _prompt"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('_item', isImage && '-image'),
    style: style,
    onClick: single ? props.onClick : undefined
  }, !isImage && preview, props.single && /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    name: 'search-plus',
    className: 'btn-view',
    href: item.url,
    targetBlank: true
  }), !props.readOnly && /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    className: 'btn-drop',
    name: 'times',
    onClick: function onClick() {
      return onDelete(item);
    }
  }), /*#__PURE__*/React.createElement(_Icon.default, {
    href: item.url,
    download: true,
    targetBlank: true,
    button: true,
    className: 'btn-download',
    name: 'download',
    onClick: noOpen
  }));
}